import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=5404134a&"
import script from "./mainFooter.js?vue&type=script&lang=js&"
export * from "./mainFooter.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports